import { useGT } from 'gt-react';
import { MarkdownWYSIWYGEditor } from '@/components/common/MarkdownWYSIWYGEditor';
import type { MentionSource } from '@/components/common/lexical-mentions/types';

/** Instruction Markdown with `{workbook:ID}` References, from the page's one mention source. */
export function WorkbookInstructionEditor({
  value,
  onChange,
  readOnly,
  mentionSources,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  readOnly: boolean;
  mentionSources: MentionSource[];
  label: string;
}) {
  const gt = useGT();
  // A read-only editor has no height of its own, so an empty one would clip its
  // placeholder to nothing: say it is empty in a line of text instead.
  if (readOnly && !value.trim())
    return (
      <p className="text-sm text-muted-foreground italic">
        {gt('No instruction yet.', { context: 'workbook empty instruction' })}
      </p>
    );
  return (
    <div
      className={
        readOnly
          ? '[&>div]:border-0 [&>div]:rounded-none [&_.lexical-editor]:p-0'
          : undefined
      }
    >
      <MarkdownWYSIWYGEditor
        initialValue={value}
        onChange={onChange}
        readonly={readOnly}
        showToolbar={!readOnly}
        height={readOnly ? 0 : 100}
        placeholder={label}
        mentionSources={mentionSources}
      />
    </div>
  );
}
